import { ApiEndpoints } from "../constants/apiEndpoints";
import apiClient from "../utils/apiClient";

class CompanyService {
  async getProfile() {
    return await apiClient.get(`${ApiEndpoints.COMPANIES}/profile`);
  }

  async updateProfile(data) {
    return await apiClient.put(`${ApiEndpoints.COMPANIES}/profile`, data);
  }

  async getStaff() {
    return await apiClient.get(`${ApiEndpoints.COMPANIES}/staff`);
  }

  async inviteStaff(email, role) {
    return await apiClient.post(`${ApiEndpoints.COMPANIES}/invitations`, {
      email,
      role,
    });
  }

  async listInvitations() {
    return await apiClient.get(`${ApiEndpoints.COMPANIES}/invitations`);
  }

  async listAddresses() {
    return await apiClient.get(`${ApiEndpoints.COMPANIES}/addresses`);
  }

  async createAddress(addressData) {
    return await apiClient.post(
      `${ApiEndpoints.COMPANIES}/addresses`,
      addressData,
    );
  }

  async updateAddress(addrId, addressData) {
    return await apiClient.put(
      `${ApiEndpoints.COMPANIES}/addresses/${addrId}`,
      addressData,
    );
  }

  async deleteAddress(addrId) {
    return await apiClient.delete(
      `${ApiEndpoints.COMPANIES}/addresses/${addrId}`,
    );
  }

  async getActivityLogs(params = {}) {
    return await apiClient.get(`${ApiEndpoints.COMPANIES}/activity-logs`, {
      params,
    });
  }

  async getApprovalRules(companyId) {
    if (!companyId) throw new Error("companyId is required for approval rules");
    return await apiClient.get(
      `${ApiEndpoints.COMPANIES}/${companyId}/approval-rules`,
    );
  }

  async saveApprovalRule(companyId, ruleData) {
    if (!companyId) throw new Error("companyId is required for approval rules");
    return await apiClient.post(
      `${ApiEndpoints.COMPANIES}/${companyId}/approval-rules`,
      ruleData,
    );
  }
}

const companyService = new CompanyService();
export default companyService;
export { companyService };
